export const BETA_TESTING_FEATURES = {
	FACIAL_RECOGNITION_AWS: 'FACIAL_RECOGNITION_AWS',
};
